import { logWarning } from '@databases/logs';
import { type KnownUser } from '@databases/types/confluence';

import { TranslatableError } from '../errors';

import { fetchConfluenceData } from './fetch';

async function batchFetchUsers(accountIds: string[]) {
  let users: KnownUser[] = [];

  try {
    const response = await fetchConfluenceData(`/api/v2/users-bulk`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ accountIds })
    });

    if (!response.ok) {
      return users;
    }

    const json = await response.json();

    users = json.results || [];
  } catch (error: unknown) {
    if (error instanceof Error) {
      logWarning(new Error(`Failed to fetch user batch: ${error.message}`));
    }

    throw new TranslatableError(
      'Failed to fetch users',
      'snackbar-error-message.failed-to-fetch-users'
    );
  }

  return users;
}

export async function getBulkUserByIds(accountIds: string[]): Promise<KnownUser[]> {
  if (accountIds.length === 0) {
    return [];
  }

  const batchSize = 250; // API limit
  const batches = [];

  for (let i = 0; i < accountIds.length; i += batchSize) {
    const batchIds = accountIds.slice(i, i + batchSize);
    batches.push(batchFetchUsers(batchIds));
  }

  const results = await Promise.all(batches);
  return results.flat();
}
